import { FieldErrors, UseFormRegister } from "react-hook-form";
import ErrorMessage from "../Input/ErrorMessage";
import styles from "./index.module.scss";

interface ICheckboxProps {
  name: string;
  register?: UseFormRegister<any>;
  errors?: FieldErrors<any>;
  children: React.ReactNode;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
const Checkbox = ({
  name,
  register,
  errors,
  children,
  checked,
  onChange,
}: ICheckboxProps) => {
  const error = errors?.[name];
  const registerProps = register ? register(name) : {};

  return (
    <div className={styles.checkboxContainer}>
      <div className={styles.checkboxGroup}>
        <input
          type="checkbox"
          id={name}
          checked={checked}
          onChange={onChange}
          {...registerProps}
        />
        <label className={styles.checkboxLabel} htmlFor={name}></label>
        {children}
      </div>

      {/* 약관 동의 에러 메시지 */}
      {error && (
        <ErrorMessage
          type="error"
          message={error?.message as string}
        ></ErrorMessage>
      )}
    </div>
  );
};

export default Checkbox;
